module.exports = "/_next/static/images/44781c2d5ed2dd60f6d37d5c6acc26e7-credito.svg";